export default "__VITE_ASSET__COdZz7XB__"